import React from 'react';

const VARIANT_CLASS = {
  primary: 'sp-btn--primary',
  outline: 'sp-btn--outline',
  white: 'sp-btn--white',
  ghost: 'sp-btn--ghost',
};

export default function Button({
  children,
  variant = 'primary',
  type = 'button',
  className = '',
  disabled,
  onClick,
  href,
  ...rest
}) {
  const cls = `sp-btn ${VARIANT_CLASS[variant] || VARIANT_CLASS.primary} ${className}`.trim();
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={cls} disabled={disabled} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
